import { PDFExport } from "@progress/kendo-react-pdf";
import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { serverInfo } from "../../../../App";
import "./CertificateLearningModal.css";

const CertificateLearningModal = (props) => {


  const { imageCdnUrl } = useContext(serverInfo);

  const pdfExportComponent = useRef(null);
  const handleButtonClick = (event) => {
    pdfExportComponent.current.save();
  };
  const [userLearningSession, setUserLearningSession] = useState({});
  const [LearningSession, setLearningSession] = useState({});
  const [starDetails, setStarDetails] = useState({});
  const [certificateData, setCertificateData] = React.useState(false);

  useEffect(() => {
    const { learningSession } = props;
    setLearningSession(learningSession);
    axios
      .get(`api/user/star-details/${learningSession.star?.id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setStarDetails(res.data.star_details);
        }
      });
    axios
      .get(`api/user/learning-session/${learningSession.slug}`)
      .then((res) => {
        if (res.data.status === 200) {
          setUserLearningSession(res.data.userLearningSession);
        }
      });

    axios
      .get(`/api/user/greeting-leraning-certificate/${learningSession.id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setCertificateData(res.data.certificateData);
        }
      });
  }, [props.learnigSession]);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="my-modal"
    >
      <Modal.Body>
        <div onClick={props.onHide} className="d-flex justify-content-end">
          <div className="closeNotificationDrop text-center">X</div>
        </div>
        <PDFExport ref={pdfExportComponent} paperSize="A2">
          {/* <h1>Ghdisf</h1> */}
          {/* <img className="img-fluid" src={certificateImg} alt="" /> */}
          <div className="row certificateBg">
            <div className="col-md-1"></div>
            <div className="col-md-7 d-flex justify-content-center align-items-center">
              <div>
                <div className="d-flex justify-content-center my-3">
                  <h3 className="certificateHeading text-center">
                    {" "}
                    Certificate of Achievement
                  </h3>
                </div>

                <h4 className="presentedText text-center">
                  This certificate is proudly presented to
                </h4>

                <h1 className="text-center celebrityName">
                  {certificateData && certificateData.name}
                </h1>

                <div className="d-flex justify-content-center">
                  <div className="underLineGold"></div>
                </div>

                <div className="d-flex justify-content-center presentedText my-3">
                  <p className="text-center">
                    This is certified by the HelloSuperStar authority to <br />
                    <b> {certificateData && certificateData.name}</b> son of
                    <b> {certificateData && certificateData.father_name}</b>.
                  </p>
                </div>

                <div className="d-flex justify-content-center presentedText">
                  <p className=" text-center">
                    an online grand talent reviewing session authorized by stars
                    and offered through HelloSuperStar.
                  </p>
                </div>

                <div className="row mx-auto d-flex justify-content-center mt-5">
                  {/* <div className="col-md-2"></div> */}
                  <div className="col-md-4 m-2">
                    <p className="presentedText SignatureTextBold text-center">
                      <img
                        src={imageCdnUrl + starDetails.signature}
                        alt="Img1"
                        className="ImgAc"
                        height={30}
                        width={200}
                      />
                    </p>
                    <div className="underLineSignature"></div>
                    <p className="presentedText text-center">
                      President's Signature
                    </p>
                  </div>
                  <div className="col-md-2"></div>
                  <div className="col-md-4 m-2">
                    <p className="presentedText SignatureTextBold text-center">
                      {moment(LearningSession.event_date).format("LL")}
                    </p>
                    <div className="underLineSignature"></div>
                    <p className="presentedText text-center">Date</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </PDFExport>
        {/* <div className="text-center my-3"> */}
        {/* <Pdf targetRef={ref} filename="code-example.pdf">
          {({ toPdf }) => ( */}
        <center>
          <button
            className="downLoadCertificate p-3 rounded-3"
            onClick={handleButtonClick}
          >
            Download
          </button>
        </center>
        {/* )}
        </Pdf> */}
        {/* </div> */}
      </Modal.Body>
    </Modal>
  );
};

export default CertificateLearningModal;
